<template>
  <v-hover v-slot:default="{ hover }">
    <div>
      <v-row no-gutters>
        <v-col cols="1">
          <v-icon x-large>mdi-account-circle</v-icon>
        </v-col>
        <v-col cols="11">
          <v-row no-gutters>
            <h4>{{attachment.user}}</h4>
            <v-spacer></v-spacer>
            <v-tooltip top v-if="hover">
              <template v-slot:activator="{ on }">
                <v-icon icon color="primary" v-on="on" @click="edit" v-if="canEdit">mdi-pencil</v-icon>
              </template>
              <span>{{$t('Edit')}}</span>
            </v-tooltip>
            <v-tooltip top v-if="hover">
              <template v-slot:activator="{ on }">
                <v-icon class="ml-2" icon color="red" v-on="on" @click="remove" v-if="canDelete">mdi-delete</v-icon>
              </template>
              <span>{{$t('Delete')}}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon class="ml-2" icon color="grey" v-on="on" @click="download" v-if="canDownload">mdi-download</v-icon>
              </template>
              <span>{{$t('Download')}}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon class="ml-2" icon color="green" v-on="on" @click="display" v-if="attachment.canDisplay">mdi-magnify</v-icon>
              </template>
              <span>{{$t('View')}}</span>
            </v-tooltip>

            <span class="ml-2">{{attachment.date}}</span>
          </v-row>
          <v-row no-gutters>
            <span>{{attachment.description}}</span>
          </v-row>
        </v-col>
      </v-row>
      <v-divider class="my-2"></v-divider>
    </div>
  </v-hover>
</template>
<script>

import AttachmentService from "@/services/AttachmentService";

export default {
  props: {
    attachment: {
      type: Object
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
    canDownload: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    edit() {
      this.$emit("on-edit-attachment", this.attachment);
    },
    display() {
      this.$emit("on-display-attachment", this.attachment);
    },
    remove() {
      this.$emit("on-remove-attachment", this.attachment.id);
    },
    download() {
      AttachmentService.download(this.attachment.id);
    },
  }
};
</script>